import { SortItem } from './member.dashboard.license.response';

export class BillingDiscount {
    MemberID: Number;
    LicenseID: Number;
    LicenseKey: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Company: string;

    Month: Number;
    Year: Number;
    Amount: Number;
    InvoiceDescription: string;
    Reason: string;
}

export class BillingDiscountsArray extends Array<BillingDiscount> {
    public LastSort: SortItem;

    constructor(...items: BillingDiscount[]) {
        super(...items);
        Object.setPrototypeOf(this, BillingDiscountsArray.prototype);
    }

}
